/**
 *
 * @author Aleynikov Boris <aleynikov.boris@gmail.com>.
 */

'use strict';

var gettextWrapper = require('mag-gettext'),
    gettext;


module.exports = {
    onSettingsInit: function ( app, callback ) {
        var data = {
            sections: [
                {
                    id: 'playback',
                    name: gettext('Playback'),
                    description: gettext('Setting video playback options'),
                    icon: 'theme-icon-monitor',
                    parent: 'system'
                }
            ],
            options: [
                // buffer size
                require('./options/buffer.size')(app),
                // Audio primary lang
                require('./options/audio.langs')(app),
                // Subtitle primary lang
                require('./options/subtitle.langs')(app),
                // Subtitle color option
                require('./options/subtitles.color')(app),
                // Subtitle size option
                require('./options/subtitle.size')(app)
            ]
        };

        // remove buffer size options in emulator
        if ( core.device && core.device.model === 'emulator' ) {
            data.options.shift();
        }

        callback(false, data);
    },
    onInit: function ( app, cb ) {
        gettextWrapper.load({
            name: core.environment.language,
            path: app.path + 'lang'
        }, function () {
            var daemon = new (require('cjs-emitter'))(),
                currentSubtitlesLang = app.storage.getItem('subtitlesLang'),
                currentSubtitlesColor = app.storage.getItem('subtitlesColor'),
                currentSubtitlesSize  = app.storage.getItem('subtitlesSize');

            gettext = gettextWrapper.gettext;

            daemon.addListener('system:start', function () {
                if ( core.backend ) {
                    core.backend.addListener('ready', function () {
                        var audioLangs = core.backend.settings['pri_audio_lang'] || core.environment.language || 'en';

                        // now we get settings from stalker
                        require('./options/audio.langs').setValue(audioLangs);
                    });
                }
            });

            if ( !currentSubtitlesLang ) {
                currentSubtitlesLang = core.environment.language;
                app.storage.setItem('subtitlesLang', currentSubtitlesLang);
            }

            if ( !currentSubtitlesColor ) {
                currentSubtitlesColor = 0xFFFFFF;
                app.storage.setItem('subtitlesColor', currentSubtitlesColor);
            }
            require('./options/subtitles.color').setValue(currentSubtitlesColor);

            if ( !currentSubtitlesSize ) {
                currentSubtitlesSize = 20;
                app.storage.setItem('subtitlesSize', currentSubtitlesSize);
            }
            require('./options/subtitle.size').setValue(currentSubtitlesSize);


            cb(null, daemon);
        });
    },
    onAppInit: function ( app, callback ) {
        callback(null, require('./plugin'));
    }
};
